import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';

const FilterPanel = ({
  searchQuery,
  setSearchQuery,
  selectedIndustry,
  setSelectedIndustry,
  industries,
  performanceRange,
  setPerformanceRange,
  dateRange,
  setDateRange,
  viewMode,
  setViewMode,
  onClearFilters
}) => {
  const hasActiveFilters = searchQuery || selectedIndustry || performanceRange?.[0] > 0 || performanceRange?.[1] < 100 || dateRange?.start || dateRange?.end;

  return (
    <div className="bg-card border border-border rounded-xl p-3 sm:p-4 space-y-3 sm:space-y-4">
      {/* Search and View Toggle */}
      <div className="flex flex-col sm:flex-row gap-3">
        <div className="flex-1">
          <div className="relative">
            <Icon
              name="Search"
              size={18}
              className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground"
            />
            <input
              type="text"
              placeholder="Search content..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e?.target?.value)}
              className="w-full h-10 pl-10 pr-4 rounded-lg border border-input bg-background text-sm text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2"
            />
          </div>
        </div>
        <div className="flex items-center gap-2 justify-end sm:justify-start">
          <button
            onClick={() => setViewMode('grid')}
            className={`
              p-2 rounded-lg transition-all duration-250
              ${viewMode === 'grid' ?'bg-primary text-primary-foreground' :'bg-muted text-muted-foreground hover:bg-muted/80'
              }
            `}
            title="Grid view"
          >
            <Icon name="Grid3x3" size={20} />
          </button>
          <button
            onClick={() => setViewMode('list')}
            className={`
              p-2 rounded-lg transition-all duration-250
              ${viewMode === 'list' ?'bg-primary text-primary-foreground' :'bg-muted text-muted-foreground hover:bg-muted/80'
              }
            `}
            title="List view"
          >
            <Icon name="List" size={20} />
          </button>
        </div>
      </div>

      {/* Filters Row */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3">
        {/* Industry Filter */}
        <Select
          placeholder="All Industries"
          value={selectedIndustry}
          onChange={setSelectedIndustry}
          options={industries}
          clearable
        />

        {/* Performance Range */}
        <div className="space-y-2">
          <label className="text-xs sm:text-sm font-medium text-foreground">
            Performance: {performanceRange?.[0]}% - {performanceRange?.[1]}%
          </label>
          <div className="flex items-center gap-2 sm:gap-3">
            <input
              type="range"
              min="0"
              max="100"
              value={performanceRange?.[0]}
              onChange={(e) => setPerformanceRange([parseInt(e?.target?.value), performanceRange?.[1]])}
              className="flex-1 h-2"
            />
            <input
              type="range"
              min="0"
              max="100"
              value={performanceRange?.[1]}
              onChange={(e) => setPerformanceRange([performanceRange?.[0], parseInt(e?.target?.value)])}
              className="flex-1 h-2"
            />
          </div>
        </div>

        {/* Date Range Start */}
        <Input
          type="date"
          label="From Date"
          value={dateRange?.start}
          onChange={(e) => setDateRange({ ...dateRange, start: e?.target?.value })}
        />

        {/* Date Range End */}
        <Input
          type="date"
          label="To Date"
          value={dateRange?.end}
          onChange={(e) => setDateRange({ ...dateRange, end: e?.target?.value })}
        />
      </div>

      {/* Clear Filters */}
      {hasActiveFilters && (
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2 pt-2 border-t border-border">
          <p className="text-xs sm:text-sm text-muted-foreground">
            Active filters applied
          </p>
          <Button
            variant="ghost"
            size="sm"
            iconName="X"
            onClick={onClearFilters}
            className="text-sm"
          >
            Clear All Filters
          </Button>
        </div>
      )}
    </div>
  );
};

export default FilterPanel;